<template>
    <div class="instrumentTime">
        <div class="layout-page-box">
            <el-form :inline="true" label-width="100px" label-position="right" class="search-form">
                <el-form-item label="姓名">
                    <el-input v-model.trim="filters.empName" clearable placeholder="请输入姓名">
                    </el-input>
                </el-form-item>
                <el-form-item label="身份">
                    <el-select @change="cardChange" v-model.trim="filters.identityId" placeholder="请选择身份" clearable>
                        <el-option v-for="(item) in cards" :key="item.id" :label="item.identity" :value="item.id"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="职级">
                    <el-select v-model.trim="filters.rankId" placeholder="请选择职级" clearable>
                        <el-option v-for="(item) in ranks" :key="item.id" :label="item.positionRank" :value="item.id"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="院区">
                    <el-select v-model.trim="filters.areaId" placeholder="请选择院区" clearable>
                        <el-option v-for="(item) in areaOptions" :key="item.areaCode" :label="item.areaName" :value="item.areaCode"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="科室">
                    <el-select v-model.trim="filters.departmentCode" placeholder="请选择科室" clearable>
                        <el-option v-for="(item) in offices" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="门诊">
                    <el-select v-model="filters.outpatientServiceCode" placeholder="请选择门诊" clearable>
                        <el-option v-for="(item) in offices" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="时间">
                    <el-date-picker v-model="filters.startTime" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="search" size="small">查询</el-button>

                </el-form-item>
            </el-form>
            <div class="buttonText">
                <el-button type="warning" @click="add" icon="el-icon-plus">新增</el-button>
                <el-button type="danger" @click="delAll" icon="el-icon-delete">批量删除</el-button>
            </div>
        </div>
        <div class="layout-page-box">
            <el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange" :height="tableHeight" :header-cell-style="{color:'#626365'}">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column sortable prop="id" label="编号" align="center"></el-table-column>
                <el-table-column sortable prop="empName" label="姓名"></el-table-column>
                <el-table-column sortable prop="identityName" label="身份"></el-table-column>
                <el-table-column sortable prop="positionRank" label="职级"></el-table-column>
                <el-table-column sortable prop="areaName" label="院区"></el-table-column>
                <el-table-column sortable prop="departmentName" label="科室"></el-table-column>
                <el-table-column sortable prop="outpatientService" label="门诊"></el-table-column>
                <el-table-column sortable prop="remark" label="备注"></el-table-column>
                <el-table-column sortable prop="createBy" label="添加人"></el-table-column>
                <el-table-column sortable prop="createTime" label="添加时间"></el-table-column>
                <el-table-column align="center" label="操作" width="160">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                        <el-button size="mini" type="danger" @click="del(scope.$index, scope.row)">删除</el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="forbidden" label="禁用" width="80">
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.forbidden" active-color="#13ce66" inactive-color="#C9C9C9" :inactive-value="0" :active-value="1" @change="change(scope.$index, scope.row)">
                        </el-switch>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination @size-change="handleSizeChange" @current-change="pageChanged" :current-page="filters.pagination.page" :page-size="filters.pagination.limit" :page-sizes="[10, 20, 30, 50]" layout="total, sizes,prev, pager, next, jumper" :total="filters.pagination.total">
            </el-pagination>
        </div>
        <!-- 新增编辑身份弹框 -->
        <el-dialog :visible.sync="dialogFormVisible" center class="dialogItem" :close-on-click-modal="false">
            <el-form :model="formData" label-width="100px">
                <el-form-item label="姓名">
                    <el-input v-model.trim="formData.empName" style="width:95%;">
                    </el-input>
                </el-form-item>
                <el-form-item label="身份">
                    <el-select @change="cardChange" v-model="formData.identityId" placeholder="请选择身份" style="width:95%;">
                        <el-option v-for="(item) in cards" :key="item.id" :label="item.identity" :value="item.id"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="职级">
                    <el-select v-model="formData.rankId" placeholder="请选择职级" style="width:95%;">
                        <el-option v-for="(item) in ranks" :key="item.id" :label="item.positionRank" :value="item.id"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="院区">
                    <el-select ref="area" v-model="formData.areaId" placeholder="请选择院区" style="width:95%;">
                        <el-option v-for="(item) in areaOptions" :key="item.areaCode" :label="item.areaName" :value="item.areaCode"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="科室">
                    <el-select multiple ref="department" v-model="formData.departmentCode" placeholder="请选择科室" style="width:95%;">
                        <el-option v-for="(item) in offices" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="门诊">
                    <el-select multiple ref="department" v-model="formData.outpatientServiceCode" placeholder="请选择门诊" style="width:95%;">
                        <el-option v-for="(item) in offices" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input v-model.trim="formData.remark" style="width:95%;">
                    </el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer partFooter">
                <el-button type="danger" @click="dialogFormVisible=false">取 消</el-button>
                <el-button type="primary" @click="doAddgoods()">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { mapState, } from 'vuex'

export default {
    name: "identity",
    computed: {
        ...mapState(['areaOptions']),
    },
    data() {
        return {
            filters: {
                types: '',
                pagination: {
                    page: 1,
                    limit: 10,
                    total: 0
                },
                startTime: '',
                endTime: '',
                outpatientService: '',
            },
            tableData: [],
            multipleSelection: [],
            dialogFormVisible: false,
            formData: {},
            cards: [],
            tableHeight: '',
            ranks: [],
            offices: [
                {
                    name: '美容皮肤科',
                    id: '001'
                },
                {
                    name: '美容外科',
                    id: '002'
                },
                {
                    name: '注射微整科',
                    id: '003'
                },
            ],
            disabled: false,
        }
    },
    created() {
        this.tableHeight = document.documentElement.clientHeight - 380
        api.requestQuiet("/identity/findIdentityRankList", {}, (res) => {
            this.cards = res.data
        }, (err) => { });
    },
    mounted() {
        /*this.init();*/
        this.query(this.filters.pagination.page);
    },
    watch: {
        $route(to, from) {
            if (this.activatedFlag) {
                this.query(this.filters.pagination.page);
            }
        },
    },
    methods: {
        cardChange(val) {
            this.cards.forEach(ele => {
                if (val == ele.id) {
                    this.ranks = ele.identityRankMenuList
                }
            });
        },
        search() {
            this.filters.pagination.page = 1
            this.refresh()
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        pageChanged(page) {
            this.filters.pagination.page = page
            this.refresh()
        },
        handleSizeChange(sizes) {
            this.filters.pagination.limit = sizes
            this.refresh()
        },
        refresh() {
            router.push({
                path: this.$route.path,
                query: _.merge({}, this.$route.query, {
                    __query: JSON.stringify(this.pagination)
                }, {
                        random: Math.random()
                    })
            })
        },
        // 禁用操作
        onChange(index, row) {
            let data = {
                id: row.id
                // 0：正常 1：禁用
            }
            api.request("/identity/forbiddenIdentityMenuById", data, (res) => {
                if (res.result == true) {
                    _g.toast("success", "状态修改成功")
                    this.query(this.filters.pagination.page)
                } else {
                    _g.toast("error", "状态修改失败")
                    this.query(this.filters.pagination.page)
                }
            })
        },
        change(index, row) {
            let data = {
                id: row.id
                // 0：正常 1：禁用
            }
            api.request("/identity/forbiddenIdentityMenuById", data, (res) => {
                if (res.result == true) {
                    _g.toast("success", "状态修改成功")
                    this.query(this.filters.pagination.page)
                } else {
                    _g.toast("error", "状态修改失败")
                    this.query(this.filters.pagination.page)
                }
            })
        },
        handleEdit(index, row) {
            this.dialogFormVisible = true
            let querys = {
                id: row.id,
            }
            api.requestQuiet("/identity/findIdentityMenuById", querys, (res) => {
                if (res.result == true) {
                    this.formData = res.data
                    this.formData.rankId = parseInt(this.formData.rankId)
                    this.cards.forEach(ele => {
                        if (this.formData.identityId == ele.id) {
                            this.ranks = ele.identityRankMenuList
                        }
                    });
                    this.formData.departmentCode = this.formData.departmentCode.split(',')
                    if (this.formData.outpatientServiceCode != '') {
                        this.formData.outpatientServiceCode = this.formData.outpatientServiceCode.split(',')
                    }
                } else {
                    _g.toast("error", res.errMsg);
                }
            }, (err) => { });
        },
        // 新增项目
        add() {
            this.dialogFormVisible = true
            // 新增置空
            this.formData = {}
        },
        doAddgoods() {
            let arr = []
            let arr1 = []
            this.offices.forEach(item => {
                this.formData.departmentCode.forEach(ele => {
                    if (item.id == ele) {
                        arr.push(item.name)
                    }
                });
                if (this.formData.outpatientServiceCode && this.formData.outpatientServiceCode != '') {
                    this.formData.outpatientServiceCode.forEach(ele => {
                        if (item.id == ele) {
                            arr1.push(item.name)
                        }
                    });
                } else {
                    this.formData.outpatientServiceCode = []
                }
            });
            let querys = {
                empName: this.formData.empName,
                identityId: this.formData.identityId,
                createBy: Lockr.get('skinEmpId'),
                id: this.formData.id,
                rankId: this.formData.rankId,
                remark: this.formData.remark,
                areaId: this.formData.areaId,
                areaName: this.$refs.area.selected.label,
                departmentName: arr.toString(),
                departmentCode: this.formData.departmentCode.toString(),
                outpatientService: arr1.toString(),
                outpatientServiceCode: this.formData.outpatientServiceCode.toString(),
            }
            api.requestQuiet("/identity/createIdentityMenu", querys, (res) => {
                if (res.result == true) {
                    this.dialogFormVisible = false
                    _g.toast("success", '操作成功');
                    this.query(this.filters.pagination.page)
                } else {
                    _g.toast("error", res.errMsg);
                }
            }, (err) => { });
        },
        // 删除项目
        del(index, row) {
            this.$confirm('确定要该条数据吗？', '删除项目', {
                center: true
            })
                .then((res) => {
                    api.request("/identity/deleteIdentityMenuById", {
                        id: row.id
                    }, (res) => {
                        if (res.result == true) {
                            _g.toast("success", "删除成功")
                            this.query(this.filters.pagination.page)
                        } else {
                            _g.toast("error", "删除失败")
                            this.query(this.filters.pagination.page)
                        }
                    })
                }).catch((err) => {
                    // this.$message.error('删除失败！');
                })
        },
        // 批量删除
        delAll() {
            var data = this.multipleSelection;
            var id = [];
            data.map(function (item, index) {
                console.log(item)
                id.push(item.id);
            });
            this.$confirm("确定要删除选中的数据吗？", "删除项目", {
                center: true,
            })
                .then((res) => {
                    api.requestQuiet(
                        "/identity/deleteIdentityMenuAll", {
                            idList: id.toString(),
                        },
                        (res) => {
                            if (res.result == true) {
                                _g.toast("success", "删除成功");
                                this.query(this.filters.pagination.page);
                            } else {
                                _g.toast("error", "删除失败");
                                this.query(this.filters.pagination.page);
                            }
                        }
                    );
                })
                .catch((err) => {
                    // this.$message.error('删除失败！');
                });
        },
        // 查询数据列表
        query(page) {
            // console.log(this.filters.startTime)
            var querys = {
                startTime: '',
                endTime: '',
                page: page,
                size: this.filters.pagination.limit,
                empName: this.filters.empName,
                identityId: this.filters.identityId,
                areaId: this.filters.areaId,
                rankId: this.filters.rankId,
                departmentCode: this.filters.departmentCode,
                outpatientServiceCode: this.filters.outpatientServiceCode,
            }
            if (this.filters.startTime) {
                querys.startTime = this.filters.startTime[0]
                querys.endTime = this.filters.startTime[1]
            }
            api.request('/identity/findIdentityMenuPage', querys, (res) => {
                var data = res.data.list
                this.tableData = data
                this.filters.pagination.total = parseInt(res.data.count)
            })
        },
    },


}
</script>
<style scoped>
@import "../../assets/css/main.css";
.warm-row {
  background-color: red !important;
}
</style>